import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Ensures every outgoing HTTP request carries `withCredentials: true`, so
 * browser cookies (access-token, refresh-token, XSRF-TOKEN) are sent and
 * accepted regardless of destination. Angular's `provideHttpClient` has no
 * global `withCredentials` option, so this interceptor clones every request.
 */
export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req.clone({ withCredentials: true }));
};
